const landingNav = [
  { name: "Beranda", link: "#berandaSection" },
  { name: "Layanan", link: "#layananSection" },
  { name: "Fitur", link: "#fiturSection" },
  { name: "Blog", link: "#blogSection" },
];

export default landingNav;
